import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('productDefinitionService', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/definitions'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.productDefinitions,
    cacheName: 'productDefinitions'
  }));